import { render, staticRenderFns } from "./MoreIcon.vue?vue&type=template&id=4bc9d7e6&scoped=true"
import script from "./MoreIcon.vue?vue&type=script&lang=js"
export * from "./MoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9d7e6",
  null
  
)

export default component.exports